export const ANIMATION_STATE = {
  OPEN: 'open',
  CLOSED: 'closed',
};

export const ANIMATION_CLICK = {
  [ANIMATION_STATE.OPEN]: {
    height: 'auto',
    opacity: 1,
    transition: {
      type: 'spring',
      damping: 10,
      mass: 0.5,
    },
  },
  [ANIMATION_STATE.CLOSED]: {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
    transition: {
      damping: 10,
      mass: 0.5,
    },
  },
};

export const ANIMATION_HOVER = {
  [ANIMATION_STATE.OPEN]: {
    opacity: 1,
    x: 0,
    zIndex: 11,
    transition: {
      type: 'spring',
    },
  },
  [ANIMATION_STATE.CLOSED]: {
    opacity: 0,
    x: 20,
    transitionEnd: { zIndex: -1 },
  },
};
